import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/ShootingLocationApi/';
// 文件上传 MP4 新增文件
export const addShootingLocation = (data)=>{
  return getInterface.post(`${prefixUrl}addShootingLocation`, data);
}
// 文件上传 MP4 更新文件
export const updateShootingLocation = (data)=>{
  return getInterface.post(`${prefixUrl}updateShootingLocation`, data);
}
// 文件上传 list
export const queryShootingLocationList = (data)=>{
  return getInterface.post(`${prefixUrl}queryShootingLocationList`, data);
}